import * as React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Button, CssBaseline, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, Stack, Toolbar, Tooltip, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, useNavigate } from 'react-router-dom';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
// import HealingIcon from '@mui/icons-material/Healing';
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';
// import AnnouncementIcon from '@mui/icons-material/Announcement';
// import GradingIcon from '@mui/icons-material/Grading';
// import AnalyticsIcon from '@mui/icons-material/Analytics';
// import EngineeringIcon from '@mui/icons-material/Engineering';
// import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import ListOfStaff from '../../components/list_of_staff';
import StaffOnBoarding from '../form_screens/staff_form';
// import { ListOfStaffAvailbaleShift } from '../../components/list_of_staff_available_shift';
import { HeaderToolbar } from '../../components/header/header_toolbar';
import { useSelector } from 'react-redux';
import { staffDetailsId } from '../../middleware/reducers/history_reducers';
import { useDispatch } from 'react-redux';

const drawerWidth = 70;

const StaffDashboard = (props) => {
    const navigate = useNavigate()
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const _history = useSelector((state) => state._history.staff_details_id);
    const [userSelected, setUserSelected] = React.useState(null);
    const dispatch = useDispatch()

    React.useEffect(() => {
        setUserSelected(_history)
    }, [_history]);

    const location = useLocation();
    const [options, setOptions] = React.useState([
        {
            option: "Staff",
            icon: <PeopleAltIcon fontSize={"large"} />,
            active: true,
            screen: <ListOfStaff />
        },
        {
            option: "Staff Onboarding",
            icon: <GroupAddIcon fontSize={"large"} />,
            active: false,
            screen: <StaffOnBoarding />
        },
        // {
        //     option: "Performance Review / Appraisals",
        //     icon: <AnalyticsIcon fontSize={"large"} />,
        //     active: false,
        //     // screen: <StaffOnBoarding />
        // },
        // {
        //     option: "Leave Application",
        //     icon: <ManageHistoryIcon fontSize={"large"} />,
        //     active: false,
        //     // screen: <StaffOnBoarding />
        // },
        // {
        //     option: "Staff Warnings",
        //     icon: <AnnouncementIcon fontSize={"large"} />,
        //     active: false,
        //     // screen: <StaffOnBoarding />
        // },
    ]);

    React.useEffect(() => {
        if (location.state) {
            handleMenuItem("", location.state.activeOption)
        }
    }, [location]);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleMenuItem = (option, i) => {
        const copy = [...options];
        for (const key in copy) {
            if (key === String(i)) {
                copy[key].active = true
            } else {
                copy[key].active = false
            }
        }
        setOptions(copy);
    }

    const drawer = (
        <div style={{ overflow: 'hidden' }}>
            <Toolbar onClick={() => navigate(-1)} sx={{ justifyContent: 'center' }}>
                <img alt="Logo" style={{ width: 40, objectFit: 'fitt' }} src="/assets/icons/logo-without-text.png" />
            </Toolbar>
            <Divider />
            <List sx={{ pt: 0 }}>
                {options.map((v, i) => (
                    <ListItem key={i} disablePadding sx={{ backgroundColor: v.active ? "#013447" : "#ffffff", }}>
                        <ListItemButton onClick={() => handleMenuItem(v.option, i)}>
                            <Tooltip title={v.option} placement="right">
                                <ListItemIcon style={{ color: v.active ? "#ffffff" : "#013447", }}>
                                    {v.icon}
                                </ListItemIcon>
                            </Tooltip>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </div>
    );

    // Remove this const when copying and pasting into your project.
    const container = window !== undefined ? () => window().document.body : undefined;
    const activeTab = options.find((e) => e.active)
    return (
        <Box sx={{ display: 'flex', overflow: "hidden", bgcolor: "#F5F7F6" }}>
            <CssBaseline />
            <AppBar
                color="primaryHeader"
                position="fixed"
                elevation={0}
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography color={"secondary"} style={{ fontFamily: "Roboto-Bold", fontSize: 24 }}>
                        {activeTab?.option}
                    </Typography>
                    {userSelected && (
                        <Box sx={{ flexGrow: 1, justifyContent: "center", display: { xs: 'none', md: 'flex', lg: 'flex' }, }}>
                            <Stack direction={"row"} spacing={2}>
                                <Button color={"primary"} variant="outlined" sx={{ boxShadow: "0px 1px 5px 1px lightgrey", fontSize: "0.9em", bgcolor: "#ffffff", fontFamily: "Roboto-Bold", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                                    Export as PDF
                                </Button>
                                <Button color={"primary"} variant="outlined" sx={{ boxShadow: "0px 1px 5px 1px lightgrey", fontSize: "0.9em", bgcolor: "#ffffff", fontFamily: "Roboto-Bold", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                                    Export as CSV
                                </Button>

                            </Stack>
                        </Box>
                    )}
                    <Box sx={{ flexGrow: 1, justifyContent: "flex-end", display: { xs: 'none', md: 'flex', lg: 'flex' }, }}>
                        {userSelected && (
                            <Box sx={{ display: "flex", alignItems: "center", }}>
                                <Button onClick={() => { dispatch(staffDetailsId(null)) }} color={"primary"} variant="outlined" sx={{ boxShadow: "0px 1px 5px 1px lightgrey", fontSize: "0.9em", bgcolor: "#ffffff", fontFamily: "Roboto-Bold", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                                    Back to Dashboard
                                </Button>
                            </Box>
                        )}
                        <HeaderToolbar />
                    </Box>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{
                    mt: "3.5%",
                    flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` }, overflowY: "scroll", height: "calc(90vh)",
                }}
            >
                {activeTab.screen}
            </Box>
        </Box>
    );
};

StaffDashboard.propTypes = {
    window: PropTypes.func,
};

export default StaffDashboard;